module.exports = __webpack_public_path__ + "static/media/dz.b03e5aec.svg";